export default {
    driver_performance_cases_create_createCases: "Crear Casos de Entrenamiento",
    driver_performance_cases_create_select: "Seleccionar",
    // Driver Scope Section
    driver_performance_cases_create_driverScope: "Alcance de Conductores",
    driver_performance_cases_create_milesDriven: "Millas Conducidas",
    driver_performance_cases_create_milesDrivenDetail: "Incluir conductores que hayan viajado más que la distancia seleccionada.",
    driver_performance_cases_create_riskScore: "Puntuación de Riesgo",
    driver_performance_cases_create_riskScoreDetail: "Incluir conductores que tengan una puntuación de riesgo mayor que el valor seleccionado.",
    // Limited By Section
    driver_performance_cases_create_limitedBy: "Limitado Por",
    driver_performance_cases_create_lastCoached: "Último Entrenamiento (Días)",
    driver_performance_cases_create_lastCoachedDetail: "Omitir conductores que hayan sido entrenados dentro del valor seleccionado.",
    // Event Types to Include Section
    driver_performance_cases_create_eventTypesToInclude: "Tipos de Eventos a Incluir",
    driver_performance_cases_create_eventStatusQueueForCoaching: "Estado de Evento en Cola para Entrenamiento",
    driver_performance_cases_create_eventStatusQueueForCoachingDetail: "Incluir eventos que tengan un estado de 'Cola para Entrenamiento'",
    driver_performance_cases_create_severityScore: "Puntuación de Severidad",
    driver_performance_cases_create_severityScoreDetail: "Incluir eventos que tengan una puntuación de severidad mayor que el valor seleccionado.",
    driver_performance_cases_create_byFrequency: "Por Frecuencia",
    driver_performance_cases_create_byFrequencyDetail: "Incluir los tipos de eventos que ocurren con más frecuencia, hasta el valor seleccionado",
    driver_performance_cases_create_noteEventsCaped: "Nota: Los eventos seleccionados estarán limitados a 100 por conductor",
    // Limit Examples Section
    driver_performance_cases_create_limitExamples: "Límite de Ejemplos",
    driver_performance_cases_create_maximumEventsPerEventType: "Máximo de Eventos por Tipo de Evento",
    driver_performance_cases_create_maximumEventsPerEventTypeDetail: "Número máximo de ejemplos por tipo de evento",
    // Common
    driver_performance_cases_create_all: "Todos",
    driver_performance_cases_create_miles: "Millas",
    driver_performance_cases_create_kilometers: "Kilómetros",
    driver_performance_cases_create_note: "Nota",
    driver_performance_cases_create_eventNote: "Los eventos asociados a conductores con casos de entrenamiento activos se agregarán a esos casos.",
    driver_performance_cases_create_send: "Enviar",
    driver_performance_cases_create_saveSuccessfully: "El proceso para generar casos automáticamente de entrenamientos se ha iniciado correctamente.",
    driver_performance_cases_create_saveError: "Ocurrió un error al crear los casos",
    driver_performance_cases_all: "Todos",
    driver_performance_cases_create_kilometersDriven: "Kilómetros Conducidos",
};
